// utils.js
import * as searchUtils from './searchUtils.js';
import * as debugUtils from './debugUtils.js';

// Export all search utils under a search namespace
export default {
    search: {
        ...searchUtils
    },
    debug: {
        ...debugUtils
    }
    
    // You can add other utility groups here
    // otherUtils: {...}
};